import styled from 'styled-components';

export const Alternative = styled.div`
  ${({ theme: { font } }) => font.t2};
  color: ${({ theme: { color } }) => color.ui2};
  text-align: center;
`;
